//export const API_url = 'http://localhost:3001';

export const API_url = 'https://api.ipborisov.ru';
